module.exports = __webpack_public_path__ + "img/step-4.38abb51c.gif";